import { httpClient } from '../http/httpClient'

export async function disableTable(id: string) {
  const { data } = await httpClient.patch(`/table/${id}/disable`)

  return data
}
